import React, { useState, useRef, useEffect } from 'react'
import { message } from 'antd'
import { hasInspirationAuth } from 'meinian-package/src/utils/auth'
import util from 'meinian-package/src/utils/util'
import Modal from 'meinian-package/src/component/modal'
import Input from 'meinian-package/src/baseComponent/input'
import Switch from 'meinian-package/src/baseComponent/switch'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import Button from 'meinian-package/src/baseComponent/button'
import { SHARE_TYPE } from 'common/config/enum'
import './index.less'

const updateShareStatus = async (params) => {
  try {
    await request.get('/zhikuan/ins/inspiration/update-share-status', { params })
  } catch (err) {
    console.error(err)
  }
}

const Share = () => {
  return <div className="meinian-coll-share">
    <div className="icon"><Icon type="m-lianjie" /></div>
    <div className="text">开启后，可通过链接分享灵感集</div>
  </div>
}

export const Sharing = (props) => {
  const { inspirationId, name, onChange, auth, isChild } = props
  const [shareUrl, setShareUrl] = useState('')
  const [shareStatus, setShareStatus] = useState(true)
  const $link = useRef()
  useEffect(() => {
    fetchUrl()
  }, [inspirationId])
  const fetchUrl = async () => {
    try {
      const res = await request.get('/ins/inspiration/generate-share-url', { params: { inspirationId, shareType: SHARE_TYPE.SHARE } })
      setShareUrl(`【知衣科技】${window.location.protocol}//${window.location.host}/meinian/home/coll/detail/${res}?shareUrl=${res}，点击链接，登录后查看灵感集《${name}》`)
      request.track({ code: 6400004, type: `分享灵感集-${inspirationId}` })
    } catch (e) {
      console.error(e)
    }
  }
  const onCopy = () => {
    $link.current.$input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      message.success('复制成功')
    } else {
      message.error('该浏览器不支持复制功能')
      console.error('该浏览器不支持复制功能')
    }
    util.track('mn-inspiration-share-copy', {
    })
  }
  return <div className="meinian-coll-sharing">
    <div className="des">获得链接的人即可访问该灵感集</div>
    <Input
      readonly
      ref={$link}
      value={shareUrl}
      suffix={<Button style={{ marginLeft: 16 }} disabled={!shareUrl} onClick={() => onCopy()}>复制链接</Button>}
    />
    <div className="tip">复制链接后，可分享至微信或钉钉</div>
    {
      hasInspirationAuth(isChild, auth, ['F10', 'FC11', 'FC11_CREATOR']) ? <div className="foot-switch">
        <span>关闭分享&nbsp;&nbsp;</span>
        <Switch
          active={shareStatus}
          onChange={async (val) => {
            await updateShareStatus({ inspirationId: props.inspirationId, shareStatus: val ? 1 : 0 })
            setShareStatus(val)
            onChange && onChange(val)
          }}
        />
        <i>{props.cooperation ? '关闭后仅团队超管及协作成员可查看该灵感集' : '关闭后自己及超管可以查看'}</i>
      </div> : null
    }
  </div>
}

Share.show = (props) => {
  const { onChange, auth, isChild } = props
  Modal.confirm({
    title: '链接分享灵感集',
    children: <Share />,
    confirmText: '开启分享',
    onOk: hasInspirationAuth(isChild, auth, ['F10', 'FC11', 'FC11_CREATOR']) ? async () => {
      await updateShareStatus({ inspirationId: props.inspirationId, shareStatus: 1 })
      Sharing.show(props)
      onChange && onChange(true)
    } : () => { return message.warning('暂无权限') }
  })
}

Sharing.show = (props) => {
  Modal.info({
    title: '链接分享灵感集',
    hiddenFooter: true,
    className: 'mn-share-modal',
    children: <Sharing {...props} />,
  })
}
export default Share
